import { useState } from "react"
import * as PropTypes from "prop-types"
import { sendEvent } from "scripts/GoogleAnalytics"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import Icon from "components/icons/icon"
import Typography from "components/styled/Typography"
import Arrow from "components/icons/arrow"

const Wrapper = styled.div`
  margin-bottom: 3px;
  background: ${({ theme }) => theme.colors.white};
`

const Header = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 60px;
  margin: 0;
  padding: 15px 35px 15px 10px;
  border: none;
  background: transparent;
  text-align: inherit;
`

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  transition: transform 0.25s ease-in-out;

  &.active {
    transform: translateY(-50%) rotate(90deg);
  }
`

const Dropdown = styled.div`
  max-height: 0;
  padding: 0 10px;
  transition: max-height 0.3s ease, padding 0.25s ease;
  overflow: hidden;

  &.active {
    padding: 5px 10px 15px;
    max-height: 500px;
  }
`

const Text = styled(Typography)`
  margin: 5px 0;
`

export default function ExtrasList(props) {
  const { page, list, title } = props
  const t = useT()
  const [isOpen, setIsOpen] = useState(false)

  if (!list.length) return null

  const toggle = () => {
    sendEvent("Extras", { event_category: page, event_label: isOpen ? `View less ${title}` : `View more ${title}` })
    setIsOpen(!isOpen)
  }

  return (
    <Wrapper>
      <Header onClick={toggle}>
        <Typography variant="title4" weight="bold">
          {t(`car_data.extras.${title}`)}
        </Typography>
        <StyledIcon size="xs" color="deepPink" className={isOpen ? "active" : null} Icon={Arrow} />
      </Header>
      <Dropdown className={isOpen ? "active" : null}>
        {list.map(item => (
          <Text key={item} color="skyBlue">
            {item}
          </Text>
        ))}
      </Dropdown>
    </Wrapper>
  )
}

ExtrasList.defaultProps = {
  list: []
}

ExtrasList.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired
}
